import Swiper, { Navigation } from 'swiper';
export const initPostRelated = () => {
    const relatedSlider = document.querySelector('.js-related-slider');
    if (relatedSlider && relatedSlider instanceof HTMLElement) {
        const swiper = new Swiper(relatedSlider, {
            modules: [Navigation],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 18,
            speed: 600,
            navigation: {
                prevEl: '.js-nav-prev',
                nextEl: '.js-nav-next',
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
            },
        });
    }
};
